import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    footer: en,
  },
  fr: {
    footer: fr,
  },
};
